<ng-template #pdfPreviewModal let-c="close" let-d="dismiss">
  <div class="modal-header d-flex justify-content-between align-items-center py-2 px-3 bg-light border-bottom">
    <div class="d-flex align-items-center gap-2">
      <i class="fas fa-file-pdf text-danger fs-5"></i>
      <h6 class="modal-title fw-bold mb-0 text-dark">Ficha Oficial de Solicitud de Incorporación</h6>
    </div>
    <div class="d-flex align-items-center gap-2">
      @if (!isGeneratingPdf() && rawPdfBlobUrl) {
        <a [href]="rawPdfBlobUrl" target="_blank" class="btn btn-outline-primary btn-sm">
          <i class="fas fa-external-link-alt me-1"></i> Abrir en pestaña
        </a>
        <button class="btn btn-primary btn-sm" (click)="downloadPdf()">
          <i class="fas fa-download me-1"></i> Descargar
        </button>
      }
      <button type="button" class="btn-close ms-2" (click)="d('Cross click')" aria-label="Close"></button>
    </div>
  </div>
  <div class="modal-body p-0 d-flex align-items-center justify-content-center bg-secondary-subtle" style="min-height: 550px;">
    @if (isGeneratingPdf()) {
      <div class="text-center p-5">
        <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status"></div>
        <h5 class="fw-bold text-dark">Generando Documento Oficial</h5>
        <p class="text-muted small mb-0">Consolidando antecedentes del postulante y vehículo...</p>
      </div>
    }
    @if (!isGeneratingPdf() && pdfSrcUrl()) {
      <iframe [src]="pdfSrcUrl()" style="width: 100%; height: 75vh; border: none;"></iframe>
    }
  </div>
</ng-template>

<!-- Tabla oculta para renderizado estructurado con jsPDF-AutoTable -->
<div style="display: none;">
  <table id="membership-report-table" style="width: 100%; font-family: 'Helvetica', Arial, sans-serif; color: #212529; background-color: #ffffff; border: 1px solid #999a9a;">
    <tbody>
      <!-- Seccion 1: Identificacion de la Solicitud y Entidad -->
      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 10px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          1. ANTECEDENTES DE LA SOLICITUD
        </th>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt; width: 22%;">Entidad FPV</td>
        <td style="padding: 6px 8px; font-size: 8.5pt; width: 28%;">{{ entityDisplay }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt; width: 22%;">Folio Solicitud</td>
        <td style="padding: 6px 8px; font-size: 8.5pt; width: 28%;">#{{ request()?.id ?? request()?.uuid?.substring(0, 8) ?? 'N/A' }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Fecha Registro</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ request()?.createdAt ? (request()?.createdAt | date: 'dd/MM/yyyy HH:mm') : 'N/A' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Estado Trámite</td>
        <td style="padding: 6px 8px; font-size: 8.5pt; font-weight: bold;">{{ statusDisplay }}</td>
      </tr>

      <!-- Seccion 2: Datos del Socio / Postulante -->
      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 10px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          2. ANTECEDENTES DEL SOCIO / POSTULANTE
        </th>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Nombre Completo</td>
        <td colspan="3" style="padding: 6px 8px; font-size: 8.5pt; font-weight: bold;">{{ partyFullName }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">RUT</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveParty?.rut || 'No registrado' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Tipo / Grupo</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ partyGroupDisplay }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Correo Electrónico</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveParty?.mail || 'No informado' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Teléfono Móvil</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveParty?.mobileNumber || 'No informado' }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Fecha Nacimiento</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveParty?.birthday ? (effectiveParty?.birthday | date: 'dd/MM/yyyy') : 'No registrada' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Vigencia Socio</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveParty?.statusSlug || 'PENDING' }}</td>
      </tr>

      <!-- Seccion 3: Datos del Vehiculo -->
      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 10px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          3. ANTECEDENTES DEL VEHÍCULO
        </th>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Placa Patente</td>
        <td style="padding: 6px 8px; font-size: 8.5pt; font-weight: bold;">{{ effectiveVehicle?.plate || 'No registrada' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Año Fabricación</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveVehicle?.year || 'N/A' }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Marca / Modelo</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ vehicleDescDisplay }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Color</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveVehicle?.color || 'N/A' }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">N° Motor</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveVehicle?.motorNumber || 'N/A' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">N° Chasis / VIN</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveVehicle?.chassisNumber || effectiveVehicle?.vin || 'N/A' }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Valor Comercial</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveVehicle?.commercialValue ? ('$ ' + (effectiveVehicle?.commercialValue | number: '1.0-0')) : 'No valorizado' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 6px 8px; font-size: 8.5pt;">Estado Vehículo</td>
        <td style="padding: 6px 8px; font-size: 8.5pt;">{{ effectiveVehicle?.statusSlug || 'PENDING' }}</td>
      </tr>

      <!-- Seccion 4: Documentacion y Declaracion -->
      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 10px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          4. DECLARACIÓN DE ANTECEDENTES
        </th>
      </tr>
      <tr>
        <td colspan="4" style="padding: 10px 12px; font-size: 8pt; color: #495057; line-height: 1.4;">
          El postulante y la entidad declaran que los antecedentes individuales y del vehículo presentados en esta solicitud son fidedignos y se encuentran respaldados por la documentación legal requerida por el reglamento del Fondo de Protección Vehicular (FPV).
        </td>
      </tr>
    </tbody>
  </table>
</div>
